import { CardVariant } from "../models/CardVariant";
import { DeckState } from "../models/Deck";

export function generateUntapInDeck(deck: DeckState, cardsBySerialDictionary: Record<string, CardVariant>, lbDeck: boolean): string {
    let result = "";

    Object.entries(deck.editableFields.unsaved.totalCardsBySerial).forEach(([serial, quantity]) => {
        const match = cardsBySerialDictionary[serial];
        if (!match) {
            return;
        }

        if (lbDeck && !match.card.isLB) {
            return;
        }

        if (!lbDeck && match.card.isLB) {
            return;
        }

        result = `${result}\n${quantity} ${match.card.name} (${serial})`;
    });

    return result;
}